import { DEFAULT_LOCALE, isSupportedLocale } from './constants';

/** 前端 AppLocale → 请求头 / 后端 language */
export function mapAppLocaleToBackendLanguage(appLocale) {
  var map = {
    'zh-CN': 'zh-CN',
    'zh-TW': 'zh-HK',
    en: 'en-US',
  };
  if (map[appLocale]) {
    return map[appLocale];
  }
  return 'zh-CN';
}

export function mapBackendLanguageToAppLocale(backendLang) {
  if (!backendLang) {
    return null;
  }
  var map = {
    'zh-CN': 'zh-CN',
    'zh-HK': 'zh-TW',
    'zh-TW': 'zh-TW',
    'en-US': 'en',
    en: 'en',
  };
  var locale = map[backendLang];
  return isSupportedLocale(locale) ? locale : null;
}

export function getBackendLanguageFromAppLocale(appLocale) {
  if (!isSupportedLocale(appLocale)) {
    return mapAppLocaleToBackendLanguage(DEFAULT_LOCALE);
  }
  return mapAppLocaleToBackendLanguage(appLocale);
}
